module.exports = __webpack_public_path__ + "img/cloudflare.bff6acf8.svg";